<!--
  Manpower Requisition Form — Figma Web application (node 35182-217)
  https://www.figma.com/design/VM4FnM9cLlftlTKDDQBqBE/Web-application?node-id=35182-217&m=dev
-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="hmf">
   <header class="hmf__page-head">
    <div class="hmf__title-row">
      <h1 class="hmf__title">Manpower Requisition Form</h1>
      <div class="mrf-header-statuses">
        <div class="mrf-header-status" *ngIf="requestStatusLabel">
          <span class="mrf-header-status__lbl">MRF Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="requestStatusTone">{{ requestStatusLabel }}</span>
        </div>
        <div class="mrf-header-status" *ngIf="onboardingStatusLabel">
          <span class="mrf-header-status__lbl">Onboarding Status</span>
          <span class="mrf-header-status__sep">-</span>
          <span class="mrf-header-status__val" [attr.data-tone]="onboardingStatusTone">{{ onboardingStatusLabel }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="hmf__entity-row">
      <mat-select class="hmf__mat-select hmf__mat-select--entity" placeholder="Select Entity">
        <input matInput [matAutocomplete]="entityAuto" [formControl]="entity" class="hmf__mat-select-input"
          placeholder="Enter entity name to select" />
        <mat-autocomplete autoActiveFirstOption #entityAuto="matAutocomplete"></mat-autocomplete>
        <mat-option *ngFor="let item of entityOptions">{{ item?.entityName }}</mat-option>
      </mat-select>
    </div> -->
  </header> 

  <div class="hmf__panel" [class.hmf__panel--readonly]="!canEditRequestForm">
    <!-- 1 Basic Information -->
    <section class="hmf__sec hmf__sec--blue" aria-labelledby="hmf-s1">
      <span class="hmf__step hmf__step--blue" aria-hidden="true">1</span>
      <h2 id="hmf-s1" class="hmf__sec-title hmf__sec-title--blue">Basic Information</h2>

      <div class="hmf__row hmf__row--5">
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-campus">Campus Name</label>
          <mat-select id="hmf-campus" class="hmf__mat-select" placeholder="Select campus" [formControl]="campus2"
            (selectionChange)="onCampusSelectionChange($event)">
            <input matInput [matAutocomplete]="campusAuto" [formControl]="campus" class="hmf__mat-select-input"
              placeholder="Enter campus name to select" />
            <mat-autocomplete autoActiveFirstOption #campusAuto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of campusOptions | async; trackBy: trackByCampusId" [value]="item?.campusName">
              {{ item?.campusName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-emp-type">Employee Type</label>
          <mat-select id="hmf-emp-type" class="hmf__mat-select" placeholder="Select employee type"
            [formControl]="employeeType2">
            <input matInput [matAutocomplete]="empTypeAuto" [formControl]="employeeType" class="hmf__mat-select-input"
              placeholder="Enter employee type to select" />
            <mat-autocomplete autoActiveFirstOption #empTypeAuto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of employeeTypeOptions | async" [value]="item?.employeeType">
              {{ item?.employeeType }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-teach-type">Teaching Type</label>
          <mat-select id="hmf-teach-type" class="hmf__mat-select" placeholder="Select teaching type"
            [formControl]="teachingType2" (selectionChange)="onTeachingTypeSelectionChange($event)">
            <input matInput [matAutocomplete]="teachTypeAuto" [formControl]="teachingType" class="hmf__mat-select-input"
              placeholder="Enter teaching type to select" />
            <mat-autocomplete autoActiveFirstOption #teachTypeAuto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of teachingTypeOptions | async"
              [value]="item?.roleType || item?.TeachType">
              {{ item?.roleType || item?.TeachType }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-dept">Department</label>
          <mat-select id="hmf-dept" class="hmf__mat-select" placeholder="Select department" [formControl]="department2">
            <input matInput [matAutocomplete]="deptAuto" [formControl]="department" class="hmf__mat-select-input"
              placeholder="Enter department to select" />
            <mat-autocomplete autoActiveFirstOption #deptAuto="matAutocomplete"></mat-autocomplete>
            <mat-option
              *ngFor="let item of departmentOptions | async"
              [value]="item?.deptName ?? item?.departmentName"
              (click)="designationChange(item)"
            >
              {{ item?.deptName ?? item?.departmentName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-desig">Designation</label>
          <mat-select id="hmf-desig" class="hmf__mat-select" placeholder="Select designation"
            [formControl]="designation2" (selectionChange)="onDesignationSelectionChange($event)">
            <input matInput [matAutocomplete]="desigAuto" [formControl]="designation" class="hmf__mat-select-input"
              placeholder="Enter designation to select" />
            <mat-autocomplete autoActiveFirstOption #desigAuto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of designationOptions | async" [value]="item?.desigName ?? item?.designation">
              {{ item?.desigName ?? item?.designation }}
            </mat-option>
          </mat-select>
        </div>

        <div class="hmf__fld" *ngIf="showSubjectSelection">
          <label class="hmf__lbl" for="hmf-subject">Subject</label>
          <mat-select id="hmf-subject" class="hmf__mat-select" placeholder="Select subject" [formControl]="subject2">
            <input matInput [matAutocomplete]="subjectAuto" [formControl]="subject" class="hmf__mat-select-input"
              placeholder="Enter subject to select" />
            <mat-autocomplete autoActiveFirstOption #subjectAuto="matAutocomplete"></mat-autocomplete>
            <mat-option *ngFor="let item of subjectOptions | async" [value]="item?.subName ?? item?.subjectName">
              {{ item?.subName ?? item?.subjectName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld" *ngIf="!isNonTeachRoleType()">
          <label class="hmf__lbl" for="hmf-workload">WorkLoad per day</label>
          <input
            id="hmf-workload"
            type="text"
            class="hmf__inp"
            placeholder="Enter"
            maxlength="1"
            inputmode="numeric"
            [formControl]="workload"
            (input)="onWorkloadInput($event)"
          />
        </div>
      </div>
    </section>

    <!-- 2 Position Type -->
    <section class="hmf__sec hmf__sec--purple" aria-labelledby="hmf-s2">
      <span class="hmf__step hmf__step--purple" aria-hidden="true">2</span>
      <h2 id="hmf-s2" class="hmf__sec-title hmf__sec-title--purple">Position Type</h2>
      <p class="hmf__lead">
        Whether replacement or a new position to the existing altogether?
      </p>

      <div class="hmf__tabs" role="tablist" aria-label="Position type">
        <button type="button" role="tab" class="hmf__tab" [class.hmf__tab--on]="isPosTab('Replacement')"
          [attr.aria-selected]="isPosTab('Replacement')" (click)="setPosTab('Replacement')">
          <span class="hmf__tab-ico" aria-hidden="true">
            <ng-container *ngIf="!isPosTab('Replacement'); else icoRepOn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.5 1.5C9.52219 1.5 7.58879 2.08649 5.9443 3.1853C4.29981 4.28412 3.01809 5.8459 2.26121 7.67316C1.50433 9.50043 1.3063 11.5111 1.69215 13.4509C2.078 15.3907 3.03041 17.1725 4.42894 18.5711C5.82746 19.9696 7.60929 20.922 9.5491 21.3078C11.4889 21.6937 13.4996 21.4957 15.3268 20.7388C17.1541 19.9819 18.7159 18.7002 19.8147 17.0557C20.9135 15.4112 21.5 13.4778 21.5 11.5C21.5 8.84783 20.4464 6.30429 18.5711 4.42893C16.6957 2.55357 14.1522 1.5 11.5 1.5ZM11.5 20.0714C9.80473 20.0714 8.14754 19.5687 6.73797 18.6269C5.32841 17.685 4.22979 16.3464 3.58104 14.7801C2.93229 13.2139 2.76254 11.4905 3.09327 9.8278C3.424 8.1651 4.24035 6.63782 5.43909 5.43908C6.63782 4.24035 8.16511 3.424 9.8278 3.09327C11.4905 2.76254 13.2139 2.93228 14.7801 3.58103C16.3464 4.22978 17.685 5.3284 18.6269 6.73797C19.5687 8.14753 20.0714 9.80473 20.0714 11.5C20.0714 13.7733 19.1684 15.9535 17.5609 17.5609C15.9535 19.1684 13.7733 20.0714 11.5 20.0714Z"
                  fill="#666666" />
              </svg>
            </ng-container>
            <ng-template #icoRepOn>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16Z"
                  fill="#7A1BBA" />
              </svg>
            </ng-template>
          </span>
          Replacement
        </button>
        <button type="button" role="tab" class="hmf__tab" [class.hmf__tab--on]="isPosTab('New Position')"
          [attr.aria-selected]="isPosTab('New Position')" (click)="setPosTab('New Position')">
          <span class="hmf__tab-ico" aria-hidden="true">
            <ng-container *ngIf="!isPosTab('New Position'); else icoNewOn">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.5 1.5C9.52219 1.5 7.58879 2.08649 5.9443 3.1853C4.29981 4.28412 3.01809 5.8459 2.26121 7.67316C1.50433 9.50043 1.3063 11.5111 1.69215 13.4509C2.078 15.3907 3.03041 17.1725 4.42894 18.5711C5.82746 19.9696 7.60929 20.922 9.5491 21.3078C11.4889 21.6937 13.4996 21.4957 15.3268 20.7388C17.1541 19.9819 18.7159 18.7002 19.8147 17.0557C20.9135 15.4112 21.5 13.4778 21.5 11.5C21.5 8.84783 20.4464 6.30429 18.5711 4.42893C16.6957 2.55357 14.1522 1.5 11.5 1.5ZM11.5 20.0714C9.80473 20.0714 8.14754 19.5687 6.73797 18.6269C5.32841 17.685 4.22979 16.3464 3.58104 14.7801C2.93229 13.2139 2.76254 11.4905 3.09327 9.8278C3.424 8.1651 4.24035 6.63782 5.43909 5.43908C6.63782 4.24035 8.16511 3.424 9.8278 3.09327C11.4905 2.76254 13.2139 2.93228 14.7801 3.58103C16.3464 4.22978 17.685 5.3284 18.6269 6.73797C19.5687 8.14753 20.0714 9.80473 20.0714 11.5C20.0714 13.7733 19.1684 15.9535 17.5609 17.5609C15.9535 19.1684 13.7733 20.0714 11.5 20.0714Z"
                  fill="#666666" />
              </svg>
            </ng-container>
            <ng-template #icoNewOn>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 16C13.0609 16 14.0783 15.5786 14.8284 14.8284C15.5786 14.0783 16 13.0609 16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8C10.9391 8 9.92172 8.42143 9.17157 9.17157C8.42143 9.92172 8 10.9391 8 12C8 13.0609 8.42143 14.0783 9.17157 14.8284C9.92172 15.5786 10.9391 16 12 16Z"
                  fill="#7A1BBA" />
              </svg>
            </ng-template>
          </span>
          New Position
        </button>
      </div>

      <div class="hmf__row" [ngClass]="isPosTab('Replacement') ? 'hmf__row--2' : 'hmf__row--1'">
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-reason">Reason for hiring</label>
          <input
            id="hmf-reason"
            type="text"
            class="hmf__inp"
            placeholder="Enter your reason"
            [formControl]="hiringReason"
          />
        </div>
        <div class="hmf__fld" *ngIf="isPosTab('Replacement')">
          <label class="hmf__lbl" for="hmf-reason-desc">Reason Description</label>
          <mat-select
            id="hmf-reason-desc"
            class="hmf__mat-select"
            placeholder="Select"
            [formControl]="reasonDescription"
          >
            <mat-option *ngFor="let option of reasonDescriptionOptions" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </div>
      </div>

      <ng-container *ngIf="isPosTab('Replacement')">
        <div class="hmf__row" [ngClass]="isReasonExit() ? 'hmf__row--4' : 'hmf__row--3'">
          <div class="hmf__fld hmf__fld--autocomplete">
            <label class="hmf__lbl" for="hmf-eid">Payroll id</label>
            <input
              id="hmf-eid"
              type="text"
              class="hmf__inp"
              matInput
              placeholder="Enter name, payroll, aadhar or mobile (min 5 chars)"
              [formControl]="employeeId"
              [matAutocomplete]="leftEmpAuto"
              (focus)="refreshLeftEmpAutocomplete('replacement')"
            />
            <mat-autocomplete
              #leftEmpAuto="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayLeftEmpLabel"
              (optionSelected)="onLeftEmpSelected($event)"
            >
              <mat-option
                *ngFor="let item of leftEmpOptions | async; trackBy: trackByLeftEmpId"
                [value]="item"
              >
                {{ getLeftEmpOptionLabel(item) }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="hmf__fld">
            <label class="hmf__lbl" for="hmf-ename">Name</label>
            <input id="hmf-ename" type="text" class="hmf__inp" placeholder="Enter" readonly [formControl]="replacementName" />
          </div>
          <div class="hmf__fld">
            <label class="hmf__lbl" for="hmf-edes">Designation</label>
            <input id="hmf-edes" type="text" class="hmf__inp" placeholder="Enter" readonly [formControl]="replacementDesignation" />
          </div>
          <div class="hmf__fld" *ngIf="isReasonExit()">
            <label class="hmf__lbl" for="hmf-lwd">DOL</label>
            <input
              id="hmf-lwd"
              type="date"
              class="hmf__inp hmf__inp--date"
              [formControl]="lastWorkingDate"
            />
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isPosTab('New Position')">
        <div class="hmf__row hmf__row--1">
          <div class="hmf__fld">
            <label class="hmf__lbl" for="hmf-pos-desig">Designation</label>
            <mat-select id="hmf-pos-desig" class="hmf__mat-select" placeholder="Select designation" [formControl]="posDesignation2">
              <input
                matInput
                [matAutocomplete]="posDesigAuto"
                [formControl]="posDesignation"
                class="hmf__mat-select-input"
                placeholder="Enter designation to select"
              />
              <mat-autocomplete autoActiveFirstOption #posDesigAuto="matAutocomplete"></mat-autocomplete>
              <mat-option *ngFor="let item of posDesignationOptions | async" [value]="item?.desigName ?? item?.designation">
                {{ item?.desigName ?? item?.designation }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showRehiringSection">
        <label class="hmf__chk">
          <input
            type="checkbox"
            class="hmf__chk-inp"
            [checked]="rehiring"
            [disabled]="!canEditRequestForm"
            (change)="onRehiringChange($event)"
          />
          <span class="hmf__chk-ui" aria-hidden="true"></span>
          <span class="hmf__chk-txt">Rehiring</span>
        </label>

        <div class="hmf__row hmf__row--3 hmf__row--tight" *ngIf="rehiring">
        <div class="hmf__fld hmf__fld--autocomplete">
          <label class="hmf__lbl" for="hmf-prev-id">Previous Payroll Id</label>
          <ng-container *ngIf="!isRehiringFieldsLocked; else lockedPrevPayroll">
            <input
              id="hmf-prev-id"
              type="text"
              class="hmf__inp"
              matInput
              placeholder="Enter name, payroll, aadhar or mobile (min 5 chars)"
              [formControl]="prevChaitanyaId"
              [matAutocomplete]="prevLeftEmpAuto"
              (focus)="refreshLeftEmpAutocomplete('rehiring')"
            />
            <mat-autocomplete
              #prevLeftEmpAuto="matAutocomplete"
              autoActiveFirstOption
              [displayWith]="displayPrevLeftEmpLabel"
              (optionSelected)="onPrevLeftEmpSelected($event)"
            >
              <mat-option
                *ngFor="let item of prevLeftEmpOptions | async; trackBy: trackByLeftEmpId"
                [value]="item"
              >
                {{ getLeftEmpOptionLabel(item) }}
              </mat-option>
            </mat-autocomplete>
          </ng-container>
          <ng-template #lockedPrevPayroll>
            <input
              id="hmf-prev-id-ro"
              type="text"
              class="hmf__inp hmf__inp--dis"
              readonly
              tabindex="-1"
              [value]="prevChaitanyaIdDisplay"
            />
          </ng-template>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-rehiring-dob">Date of Birth</label>
          <input
            id="hmf-rehiring-dob"
            type="text"
            class="hmf__inp hmf__inp--dis"
            placeholder="Display"
            readonly
            [value]="rehiringDobDisplay"
          />
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-aadhaar">Aadhaar No.</label>
          <input
            id="hmf-aadhaar"
            type="text"
            class="hmf__inp"
            [class.hmf__inp--dis]="isRehiringFieldsLocked"
            placeholder="Enter 12 digit Aadhaar"
            [formControl]="aadharNo"
            [readonly]="isRehiringFieldsLocked"
            maxlength="12"
            inputmode="numeric"
            autocomplete="off"
            (input)="onAadhaarInput($event)"
          />
          <label
            class="hmf__attach-link"
            *ngIf="!rehiringAadhaarDocuments.length && canAddMoreRehiringAadhaarFiles() && !isRehiringFieldsLocked"
            (click)="onRehiringAadhaarAttachClick($event, rehiringAadhaarFileInput)"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z" fill="#1B6EBA"/>
            </svg>
            Upload Aadhar
          </label>
          <input
            #rehiringAadhaarFileInput
            type="file"
            hidden
            accept=".pdf,image/*"
            (change)="onRehiringAadhaarFilesSelected($event)"
          />
          <ng-container *ngTemplateOutlet="pendingChips; context: { files: rehiringAadhaarPendingFiles }"></ng-container>
          <span class="hmf__upload-error" *ngIf="rehiringAadhaarUploadError">{{ rehiringAadhaarUploadError }}</span>
          <ng-container *ngTemplateOutlet="fileChips; context: { docs: rehiringAadhaarDocuments }"></ng-container>
        </div>
      </div>
      </ng-container>
    </section>

    <!-- 3 Headcount Information -->
    <section class="hmf__sec hmf__sec--green" aria-labelledby="hmf-s3">
      <span class="hmf__step hmf__step--green" aria-hidden="true">3</span>
      <h2 id="hmf-s3" class="hmf__sec-title hmf__sec-title--green">Headcount Information</h2>
      <div class="hmf__row hmf__row--2">
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-budgeted">No. of Budgeted Positions</label>
          <input id="hmf-budgeted" type="text" class="hmf__inp hmf__inp--dis" disabled
            [value]="budgetedPositions || '—'" />
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-hc">No. of Headcount</label>
          <input id="hmf-hc" type="number" min="1" class="hmf__inp" [formControl]="noOfHeadcount" />
        </div>
      </div>
      <div class="hmf__hc-bar" role="status">
        <span class="hmf__hc-bar-ico" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM16 13C13.67 13 9 14.17 9 16.5V18H23V16.5C23 14.17 18.33 13 16 13ZM8 13C8.67 13 10.66 13.34 12 14.5C10.34 15.34 8.67 16 8 16C5.67 16 1 17.17 1 19.5V21H15V19.5C15 17.17 10.33 16 8 16Z"
              fill="#0CA766" />
          </svg>
        </span>
        <span class="hmf__hc-bar-lbl">Available Headcount (Budgeted - Actual)</span>
        <span class="hmf__hc-bar-val">{{ availableHeadcount }}</span>
      </div>
      <div class="hmf__hc-error" *ngIf="headcountError">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#d32f2f"/>
        </svg>
        <span>{{ headcountError }}</span>
      </div>
    </section>

    <!-- 4 Qualification & Skills -->
    <section class="hmf__sec hmf__sec--orange" aria-labelledby="hmf-s4">
      <span class="hmf__step hmf__step--orange" aria-hidden="true">4</span>
      <h2 id="hmf-s4" class="hmf__sec-title hmf__sec-title--orange">Qualification &amp; Skills</h2>
      <div class="hmf__row hmf__row--4 hmf__row--qual-skills">
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-qual">Educational Qualification</label>
          <mat-select id="hmf-qual" class="hmf__mat-select" placeholder="Select qualification" [formControl]="qualification2">
            <input
              matInput
              [matAutocomplete]="qualAuto"
              [formControl]="qualification"
              class="hmf__mat-select-input"
              placeholder="Enter qualification to select"
            />
            <mat-autocomplete autoActiveFirstOption #qualAuto="matAutocomplete"></mat-autocomplete>
            <mat-option
              *ngFor="let item of qualificationOptions | async"
              [value]="item?.qualificationName"
            >
              {{ item?.qualificationName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-qual2">Educational Qualification (Additional)</label>
          <mat-select id="hmf-qual2" class="hmf__mat-select" placeholder="Select qualification" [formControl]="additionalQualification2">
            <input
              matInput
              [matAutocomplete]="qual2Auto"
              [formControl]="additionalQualification"
              class="hmf__mat-select-input"
              placeholder="Enter qualification to select"
            />
            <mat-autocomplete autoActiveFirstOption #qual2Auto="matAutocomplete"></mat-autocomplete>
            <mat-option
              *ngFor="let item of additionalQualificationOptions | async"
              [value]="item?.qualificationName"
            >
              {{ item?.qualificationName }}
            </mat-option>
          </mat-select>
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-exp">Years of Experience</label>
          <input
            id="hmf-exp"
            type="text"
            class="hmf__inp"
            placeholder="e.g. 1.5"
            inputmode="decimal"
            autocomplete="off"
            maxlength="4"
            [formControl]="yearsOfExp"
            (input)="onYearsOfExpInput($event)"
          />
        </div>
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-skills">Skills</label>
          <input id="hmf-skills" type="text" class="hmf__inp" placeholder="Enter" [formControl]="skills" />
        </div>
      </div>
    </section>

    <!-- 5 Reporting Structure -->
    <section class="hmf__sec hmf__sec--teal" aria-labelledby="hmf-s5">
      <span class="hmf__step hmf__step--teal" aria-hidden="true">5</span>
      <h2 id="hmf-s5" class="hmf__sec-title hmf__sec-title--teal">Reporting Structure</h2>
      <div class="hmf__row hmf__row--1">
        <div class="hmf__fld">
          <label class="hmf__lbl" for="hmf-rm">Reporting Manager (Principal / Dean / AGM)</label>
          <mat-select id="hmf-rm" class="hmf__mat-select" placeholder="Select reporting manager" [formControl]="reportingManager2">
            <input
              matInput
              [matAutocomplete]="rmAuto"
              [formControl]="reportingManager"
              class="hmf__mat-select-input"
              placeholder="Enter manager name to select"
            />
            <mat-autocomplete autoActiveFirstOption #rmAuto="matAutocomplete"></mat-autocomplete>
            <mat-option
              *ngFor="let item of reportingManagerOptions | async"
              [value]="item?.reportingManagerName ?? item?.managerName"
            >
              {{ getReportingManagerOptionLabel(item) }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </section>

    <!-- 6 Important Guidelines -->
    <section class="hmf__sec hmf__sec--gold hmf__sec--last" aria-labelledby="hmf-s6">
      <span class="hmf__step hmf__step--gold" aria-hidden="true">6</span>
      <h2 id="hmf-s6" class="hmf__sec-title hmf__sec-title--gold">Important Guidelines</h2>
      <div class="hmf__guide-box">
        <ul class="hmf__guide">
          <li>
            Substituted positions must follow approved salary rules; replacements cannot exceed the budgeted band
            without prior approval.
          </li>
          <li>
            New campuses and branches require leadership sign-off before headcount is released for hiring.
          </li>
          <li>
            All requisitions are subject to final HR and finance validation before offer release.
          </li>
        </ul>
      </div>
    </section>

    <footer class="hmf__footer">
      <button type="button" class="hmf__btn hmf__btn--cancel" (click)="onCancel()">Cancel</button>
      <button
        type="button"
        class="hmf__btn hmf__btn--submit"
        *ngIf="canEditRequestForm"
        (click)="saveMrfForm()"
        [disabled]="isSaving || headcountError"
      >
        {{ isSaving ? (editingMrfId ? 'Editing...' : 'Submitting...') : (editingMrfId ? 'Edit Request' : 'Submit Request') }}
      </button>
    </footer>
  </div>
</div>

<ng-template #pendingChips let-files="files">
  <ul class="hmf__pending" *ngIf="files?.length">
    <li *ngFor="let file of files; let i = index" class="hmf__pending-item">
      <span
        class="hmf__file-chip-ico"
        [class.hmf__file-chip-ico--pdf]="isPendingPdfOrImage(file)"
        [class.hmf__file-chip-ico--img]="isPendingImage(file)"
      >{{ isPendingImage(file) ? 'IMG' : 'PDF' }}</span>
      <span class="hmf__pending-name" [title]="file.name">{{ file.name }}</span>
      <button
        type="button"
        class="hmf__pending-remove"
        (click)="removeRehiringAadhaarPendingFile(i)"
        aria-label="Remove file"
      >×</button>
    </li>
  </ul>
</ng-template>

<ng-template #fileChips let-docs="docs">
  <div class="hmf__file-chips" *ngIf="docs?.length">
    <ng-container *ngFor="let doc of docs">
      <button
        type="button"
        *ngIf="canDownloadDocument(doc); else fileChipStatic"
        class="hmf__file-chip"
        (click)="onDocumentDownload(doc)"
        [title]="getDocumentName(doc)"
      >
        <span
          class="hmf__file-chip-ico"
          [class.hmf__file-chip-ico--pdf]="isPdfFile(doc)"
          [class.hmf__file-chip-ico--img]="isImageFile(doc)"
        >{{ getDocumentIconLabel(doc) }}</span>
        <span class="hmf__file-chip-name">{{ getDocumentName(doc) }}</span>
      </button>
      <ng-template #fileChipStatic>
        <span class="hmf__file-chip hmf__file-chip--static" [title]="getDocumentName(doc)">
          <span
            class="hmf__file-chip-ico"
            [class.hmf__file-chip-ico--pdf]="isPdfFile(doc)"
            [class.hmf__file-chip-ico--img]="isImageFile(doc)"
          >{{ getDocumentIconLabel(doc) }}</span>
          <span class="hmf__file-chip-name">{{ getDocumentName(doc) }}</span>
        </span>
      </ng-template>
    </ng-container>
  </div>
</ng-template>